export const LOCAL_STORAGE_USER_TOKEN_KEY = "studio_footprint_user_token";
export const LOCAL_STORAGE_USER_Data_KEY = "studio_footprint_user_data";
export const APP_NAME = "Studio Footprint";
